import { render, staticRenderFns } from "./MessageReply.vue?vue&type=template&id=d6ce1fd8&scoped=true&lang=pug&"
import script from "./MessageReply.vue?vue&type=script&lang=js&"
export * from "./MessageReply.vue?vue&type=script&lang=js&"
import style0 from "./MessageReply.vue?vue&type=style&index=0&id=d6ce1fd8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ce1fd8",
  null
  
)

export default component.exports